/**
 * Modal de producto: variaciones, CompositeKN y agregar al carrito.
 */

function cknKeyFromSelection(sel) {
	if (!sel) return 'null';
	try {
		const parts = Object.entries(sel)
			.map(([g, val]) => {
				const groupIndex = parseInt(g, 10);
				if (val != null && typeof val === 'object' && !Array.isArray(val)) {
					const pairs = Object.entries(val)
						.map(([id, q]) => `${id}:${q}`)
						.sort();
					return [groupIndex, pairs.join(',')];
				}
				const arr = Array.isArray(val) ? val.map(String) : [String(val)];
				arr.sort();
				return [groupIndex, arr.join(',')];
			})
			.sort((a, b) => a[0] - b[0])
			.map(([g, v]) => `${g}:${v}`);
		return parts.join('|');
	} catch (e) {
		return 'null';
	}
}

function escCknHtml(s) {
	return String(s || '').replace(/[&<>"']/g, (c) => {
		return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
	});
}

function cknOptionPriceUsd(opt) {
	if (!opt) return 0;
	return opt.type === 'recipe' ? parseFloat(opt.price_extra || 0) || 0 : parseFloat(opt.price || 0) || 0;
}

function cknFindOption(group, key) {
	if (!group || key == null || key === '') return null;
	return (group.options || []).find(
		(o) =>
			o != null &&
			(o.type === 'recipe' ? String(o.recipe_id) === String(key) : String(o.id) === String(key))
	);
}

function cknDesdeExtraUsd(groups) {
	let extra = 0;
	(groups || []).forEach((g) => {
		const optional = !!g.optional;
		const min = optional ? 0 : parseInt(g.min || 1, 10);
		if (min <= 0) return;
		const prices = (g.options || []).map(cknOptionPriceUsd);
		if (!prices.length) return;
		prices.sort((a, b) => a - b);
		const max = parseInt(g.max || 1, 10);
		extra += prices[0] * (max > 1 ? min : 1);
	});
	return extra;
}

function cknGroupsFromEmbedded(data) {
	if (!data || !Array.isArray(data.groups)) return [];
	return data.groups.map((g) => ({
		title: g.title || 'Opciones',
		min: g.min,
		max: g.max,
		optional: !!g.optional,
		options: (g.options || []).map((opt) => {
			const isRec =
				opt.type === 'recipe' || !!(opt.lines && opt.lines.length) || !!opt.recipe_id || opt.price_extra != null;
			if (isRec) {
				return {
					type: 'recipe',
					recipe_id: opt.recipe_id,
					label: opt.label || opt.name || 'Opción',
					price_extra: parseFloat(opt.price_extra || 0) || 0,
					lines: opt.lines || [],
				};
			}
			return {
				type: 'product',
				id: opt.id,
				name: opt.name || `Opción #${opt.id || ''}`,
				price: parseFloat(opt.price || 0) || 0,
			};
		}),
	}));
}

function cknTextoPrecioOpcion(win, usd) {
	const n = parseFloat(usd) || 0;
	if (n <= 0) return '';
	if (typeof win.posknTextoPrecioDual === 'function') {
		return win.posknTextoPrecioDual(n, 'extra');
	}
	return ` (+$${n.toFixed(2)})`;
}

function cknHtmlPreciosGrupos(win, groups) {
	if (!groups || !groups.length) return '';
	let html = '<div style="font-weight:600;margin-bottom:8px;">Precios de opciones (USD y Bs.)</div>';
	groups.forEach((g) => {
		html += `<div style="margin:8px 0 4px;color:#555;font-size:12px;text-transform:uppercase;letter-spacing:.02em;">${escCknHtml(
			g.title || 'Opciones'
		)}</div>`;
		(g.options || []).forEach((opt) => {
			const name = opt.type === 'recipe' ? opt.label || opt.name || 'Opción' : opt.name || 'Opción';
			const usd = cknOptionPriceUsd(opt);
			const precio =
				typeof win.posknTextoPrecioDual === 'function'
					? win.posknTextoPrecioDual(usd, '')
					: `$${usd.toFixed(2)}`;
			html += `<div style="display:flex;justify-content:space-between;gap:10px;padding:5px 0;border-bottom:1px solid #eee;">
				<span>${escCknHtml(name)}</span>
				<span style="white-space:nowrap;font-weight:600;text-align:right;">${precio}</span>
			</div>`;
		});
	});
	html +=
		'<p style="margin:8px 0 0;font-size:12px;color:#666;">Al agregar al pedido eliges la opción y ves el total en ambas monedas.</p>';
	return html;
}

export function attachProductModalGlobals(win, $) {
	win.posknCknCache = win.posknCknCache || {};

	win.posknFormatStockSpan = (avail) => {
		if (avail === null) {
			return ' <span class="ckn-opt-stock ckn-opt-stock--na">(sin control stock)</span>';
		}
		const n = parseFloat(avail || 0);
		let cls = 'ckn-opt-stock--ok';
		let text = `Disp: ${Math.abs(n - Math.round(n)) < 0.001 ? String(Math.round(n)) : n.toFixed(2)}`;
		if (n <= 0) {
			cls = 'ckn-opt-stock--out';
			text = 'Sin stock';
		} else if (n < 5) {
			cls = 'ckn-opt-stock--low';
		}
		return ` <span class="ckn-opt-stock ${cls}">(${text})</span>`;
	};

	win.posknCknLineStockAvail = (line) => {
		const pid = parseInt(line && line.id, 10);
		if (!pid) return null;
		// Sin gestión → no limita (receta/componente no gestionado).
		if (!line.managing_stock) return null;
		return win.posknGetStockDisponible(pid, 0, line.stock, true);
	};

	win.posknCknOptionStockAvail = (opt) => {
		if (!opt) return null;
		// Recetas variables: informativas en pantalla; no limitan la venta (descuento sin bloqueo en servidor).
		if (opt.type === 'recipe') return null;
		const pid = parseInt(opt.id, 10);
		if (!pid) return null;
		if (!opt.managing_stock) return null;
		return win.posknGetStockDisponible(pid, 0, opt.stock, true);
	};

	win.posknCknOptionBlocksSale = (opt) => {
		if (!opt || opt.type === 'recipe') return false;
		const stockAvail = win.posknCknOptionStockAvail(opt);
		return stockAvail !== null && parseFloat(stockAvail) <= 0;
	};

	win.posknCknOptionStockHtml = (opt) => {
		if (!opt) return '';
		if (opt.type === 'recipe' && opt.lines && opt.lines.length) {
			let minUnits = null;
			opt.lines.forEach((line) => {
				const need = parseFloat(line.qty) || 0;
				if (need <= 0) return;
				const avail = win.posknCknLineStockAvail(line);
				if (avail === null) return;
				const units = parseFloat(avail) / need;
				if (minUnits === null || units < minUnits) minUnits = units;
			});
			if (minUnits === null) {
				return ' <span class="ckn-opt-stock ckn-opt-stock--na">(stock n/d)</span>';
			}
			return win.posknFormatStockSpan(minUnits);
		}
		const pid = parseInt(opt.id, 10);
		if (!pid) return '';
		return win.posknFormatStockSpan(win.posknCknOptionStockAvail(opt));
	};

	win.mostrarSelectorComposite = (groups) =>
		new Promise((resolve) => {
			const overlay = $('<div id="ckn-overlay"></div>').css({
				position: 'fixed',
				inset: 0,
				background: 'rgba(0,0,0,.5)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				zIndex: 13050,
			});
			const modal = $('<div></div>').css({
				background: '#fff',
				padding: '16px',
				width: '520px',
				maxHeight: '80vh',
				overflow: 'auto',
				borderRadius: '8px',
			});
			modal.append('<h3>Selecciona opciones (cantidad por sabor/opción)</h3>');
			const form = $('<div></div>');
			groups.forEach((g, gi) => {
				const optional = !!g.optional;
				const min = optional ? 0 : parseInt(g.min || 1, 10);
				const max = parseInt(g.max || 1, 10);
				const useQtyInputs = max > 1;
				const block = $('<div class="ckn-group"></div>').css({
					margin: '8px 0',
					padding: '8px',
					border: '1px solid #ddd',
					borderRadius: '6px',
				});
				const totalHint = useQtyInputs
					? min === max
						? `Debes elegir exactamente <strong>${min}</strong> en total.`
						: `Elige entre <strong>${min}</strong> y <strong>${max}</strong> en total.`
					: '';
				const minMaxLabel = optional ? '(opcional)' : useQtyInputs ? '' : `(min ${min} / max ${max})`;
				block.append(
					`<div style="font-weight:600;margin-bottom:6px;">${g.title || 'Opciones'} <span style="color:#666;font-weight:400;">${minMaxLabel}</span></div>`
				);
				if (totalHint) {
					block.append(`<p class="ckn-total-hint" style="margin:4px 0 8px;font-size:12px;color:#555;">${totalHint}</p>`);
				}
				const ul = $('<ul></ul>').css({ listStyle: 'none', padding: 0, margin: 0 });
				(g.options || []).forEach((opt) => {
					const isRec = opt.type === 'recipe';
					const optKey = isRec ? String(opt.recipe_id || '') : String(opt.id != null ? opt.id : '');
					const dispName = isRec ? opt.label || opt.name || 'Opción' : opt.name || '';
					const precioUsd = cknOptionPriceUsd(opt);
					const precioTexto = cknTextoPrecioOpcion(win, precioUsd);
					const stockHtml = win.posknCknOptionStockHtml(opt);
					const stockAvail = win.posknCknOptionStockAvail(opt);
					const blocksSale = win.posknCknOptionBlocksSale(opt);
					const li = $('<li></li>').css({
						margin: '6px 0',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						gap: '8px',
						opacity: blocksSale ? 0.55 : 1,
					});
					const safeId = String(optKey).replace(/[^a-zA-Z0-9_-]/g, '_');
					if (useQtyInputs) {
						const qtyId = `qty_gi${gi}_opt_${safeId}`;
						const maxQty =
							opt.type === 'recipe' || stockAvail === null
								? Math.max(max, 99)
								: Math.max(0, Math.floor(parseFloat(stockAvail)));
						const input = $('<input type="number" min="0" class="ckn-qty-input">')
							.attr({ id: qtyId, 'data-gi': gi, 'data-opt-id': optKey, max: maxQty > 0 ? maxQty : 0, value: 0, step: 1 });
						if (blocksSale) input.prop('disabled', true);
						li.append(
							$(`<label for="${qtyId}" style="flex:1;">${dispName}${precioTexto}${stockHtml}</label>`),
							input
						);
					} else {
						const id = `gi${gi}_opt_${safeId}`;
						const input = $('<input type="radio">').attr({ id, name: `g${gi}`, value: optKey });
						if (blocksSale) input.prop('disabled', true);
						li.append(
							input,
							$(`<label for="${id}" style="flex:1;cursor:${blocksSale ? 'not-allowed' : 'pointer'};">${dispName}${precioTexto}${stockHtml}</label>`)
						);
					}
					ul.append(li);
				});
				block.append(ul);
				if (useQtyInputs) {
					const sumSpan = $('<span class="ckn-group-sum" style="font-weight:600;margin-left:8px;">0</span>');
					block.append($('<div style="margin-top:6px;font-size:12px;">Total seleccionado: </div>').append(sumSpan));
					block.find('.ckn-qty-input').on('input', function () {
						let s = 0;
						block.find('.ckn-qty-input').each(function () {
							s += parseInt($(this).val(), 10) || 0;
						});
						sumSpan.text(s);
					});
				}
				form.append(block);
			});
			const totalBox = $(
				'<div class="ckn-total-dual" style="margin-top:12px;padding:10px 12px;background:#e8f5e9;border-radius:6px;font-weight:600;font-size:14px;"></div>'
			);
			const actualizarTotalCkn = () => {
				let extra = 0;
				groups.forEach((g, gi) => {
					const max = parseInt(g.max || 1, 10);
					if (max > 1) {
						form.find(`.ckn-qty-input[data-gi="${gi}"]`).each(function () {
							const q = parseInt($(this).val(), 10) || 0;
							if (q < 1) return;
							const opt = cknFindOption(g, $(this).attr('data-opt-id'));
							if (opt) extra += cknOptionPriceUsd(opt) * q;
						});
					} else {
						const val = form.find(`input[name="g${gi}"]:checked`).val();
						const opt = cknFindOption(g, val);
						if (opt) extra += cknOptionPriceUsd(opt);
					}
				});
				const qty = parseFloat($('#modal-cantidad').val()) || 1;
				const pa = win.productoActual || {};
				const resolved =
					typeof win.posknResolvePreciosItem === 'function'
						? win.posknResolvePreciosItem(pa)
						: { usd: parseFloat(pa.price) || 0 };
				const unit = (resolved.usd || 0) + extra;
				const total = unit * qty;
				const texto =
					typeof win.posknTextoPrecioDual === 'function'
						? win.posknTextoPrecioDual(total, '')
						: `$${total.toFixed(2)}`;
				totalBox.html(`Total (${qty} ud.): ${texto}`);
			};
			form.on('change input', 'input', actualizarTotalCkn);
			actualizarTotalCkn();
			const btns = $('<div style="text-align:right;margin-top:10px;"></div>');
			const cancelar = $('<button type="button" class="button">Cancelar</button>').on('click', () => {
				overlay.remove();
				resolve(null);
			});
			const aceptar = $('<button type="button" class="button button-primary">Aceptar</button>')
				.css({ marginLeft: '8px' })
				.on('click', function () {
					const result = {};
					let ok = true;
					groups.forEach((g, gi) => {
						const optional = !!g.optional;
						const min = optional ? 0 : parseInt(g.min || 1, 10);
						const max = parseInt(g.max || 1, 10);
						if (max > 1) {
							const qtyMap = {};
							let sum = 0;
							form.find(`.ckn-qty-input[data-gi="${gi}"]`).each(function () {
								const optId = $(this).attr('data-opt-id');
								const q = parseInt($(this).val(), 10) || 0;
								if (q > 0) {
									qtyMap[optId] = q;
									sum += q;
								}
							});
							if (sum < min || (max > 0 && sum > max)) ok = false;
							result[gi] = Object.keys(qtyMap).length ? qtyMap : null;
						} else {
							const val = form.find(`input[name="g${gi}"]:checked`).val();
							if (!optional && (val === undefined || val === '')) ok = false;
							result[gi] = val || null;
						}
					});
					if (!ok) {
						alert('Debes respetar los mínimos y máximos de cada grupo (total de cantidades por grupo).');
						return;
					}
					try {
						overlay.remove();
					} finally {
						resolve(result);
					}
				});
			btns.append(cancelar, aceptar);
			modal.append(form, totalBox, btns);
			overlay.append(modal);
			$('body').append(overlay);
		});

	win.abrirModalProducto = function abrirModalProducto(producto) {
		const freshOpen = win.posknFindProductoEnData(producto && producto.id);
		if (freshOpen) producto = Object.assign({}, freshOpen);
		win.productoActual = producto;

		function actualizarInfoStockModal() {
			const pa = win.productoActual;
			if (!pa) return;
			let variationId = parseInt($('#modal-variacion-select').val() || '0', 10);
			let fallbackStock = pa.stock;
			let managingStock = win.posknResolveManagingStock(pa, variationId);
			if (variationId && pa.variations && Array.isArray(pa.variations)) {
				const variacionSeleccionada = pa.variations.find((v) => v && parseInt(v.id, 10) === variationId);
				if (variacionSeleccionada) {
					fallbackStock = variacionSeleccionada.stock;
				}
			}
			const stockDisponible = win.posknGetStockDisponible(pa.id, variationId, fallbackStock, managingStock);
			const usaTienda =
				typeof win.posknUsaStockDeTienda === 'function'
					? win.posknUsaStockDeTienda()
					: !!(win.posknTiendaSeleccionada && parseInt(win.posknTiendaSeleccionada.id, 10) > 0);
			if (usaTienda) {
				if (stockDisponible === null) {
					$('#modal-stock-info').html('<strong>Disponibilidad:</strong> En stock');
				} else {
					$('#modal-stock-info').html(`<strong>Stock tienda:</strong> ${parseFloat(stockDisponible || 0).toFixed(2)}`);
				}
			} else if (stockDisponible === null) {
				$('#modal-stock-info').html('<strong>Disponibilidad:</strong> En stock');
			} else {
				$('#modal-stock-info').html(`<strong>Stock WooCommerce:</strong> ${parseFloat(stockDisponible || 0).toFixed(2)}`);
			}
		}

		if (!win._posknStockDegraded && typeof win.posknRefrescarStockEnVivo === 'function') {
			win.posknRefrescarStockEnVivo({ productIds: [producto.id] }).always(function () {
				const fresh = win.posknFindProductoEnData(producto.id);
				if (fresh) win.productoActual = Object.assign({}, fresh);
				actualizarInfoStockModal();
			});
		}

		$('#modal-producto-titulo').text(producto.name);
		$('#modal-precios').html(win.posknHtmlPreciosModal(producto));
		$('#modal-ckn-precios').hide().empty();
		$('#modal-cantidad').val('1').attr('min', '0.01').attr('step', '0.01');
		$('#modal-notas').val('');

		$('#modal-cantidad')
			.off('keydown')
			.on('keydown', function (e) {
				if (e.key === 'Enter') {
					e.preventDefault();
					win.agregarAlCarrito();
				}
			});
		$('#modal-notas')
			.off('keydown')
			.on('keydown', function (e) {
				if (e.key === 'Enter') {
					e.preventDefault();
					win.agregarAlCarrito();
				}
			});

		if (producto.variations && producto.variations.length > 0) {
			$('#modal-variaciones').show();
			const select = $('#modal-variacion-select');
			select.empty().append('<option value="">Seleccionar variación</option>');
			producto.variations.forEach((variation) => {
				const atributos = Object.values(variation.attributes).join(', ');
				const resolvedVar = win.posknResolvePreciosItem(variation);
				const labelVar = win.POSKN_MULTIMONEDA
					? `${atributos} - $${resolvedVar.usd.toFixed(2)} USD / Bs. ${resolvedVar.bs.toFixed(2)}`
					: `${atributos} - $${resolvedVar.usd.toFixed(2)}`;
				select.append(`<option value="${variation.id}" data-price="${resolvedVar.usd}">${labelVar}</option>`);
			});
			select.off('change').on('change', function () {
				const variationId = $(this).find('option:selected').val();
				const variacionData = producto.variations.find((v) => v && String(v.id) === String(variationId));
				$('#modal-precios').html(
					win.posknHtmlPreciosModal(variacionData || producto)
				);
				actualizarInfoStockModal();
			});
			select.off('keydown').on('keydown', function (e) {
				if (e.key === 'Enter') {
					e.preventDefault();
					win.agregarAlCarrito();
				}
			});
		} else {
			$('#modal-variaciones').hide();
		}

		$('#modal-producto').css('display', 'flex');
		win.posknMostrarPreciosCknEnFicha(producto);
		const inputCantidad = document.getElementById('modal-cantidad');
		const modalEl = document.getElementById('modal-producto');
		if (inputCantidad && modalEl) {
			function enfocarCantidad() {
				if (modalEl.style.display === 'flex') {
					inputCantidad.focus();
					inputCantidad.select();
				}
			}
			setTimeout(enfocarCantidad, 80);
			setTimeout(enfocarCantidad, 350);
		}
	};

	win.posknMostrarPreciosCknEnFicha = async function posknMostrarPreciosCknEnFicha(producto) {
		const box = $('#modal-ckn-precios');
		if (!box.length) return;
		win._posknCknFichaToken = (win._posknCknFichaToken || 0) + 1;
		const token = win._posknCknFichaToken;
		if (!producto || !producto.is_composite) {
			box.hide().empty();
			return;
		}

		const aplicarGrupos = (groups) => {
			if (token !== win._posknCknFichaToken) return;
			if (!groups || !groups.length) {
				box.hide().empty();
				return;
			}
			const extra = cknDesdeExtraUsd(groups);
			box.html(cknHtmlPreciosGrupos(win, groups)).show();
			$('#modal-precios').html(win.posknHtmlPreciosModal(producto, { desdeExtraUsd: extra }));
		};

		const embedded = cknGroupsFromEmbedded(producto.composite_data);
		if (embedded.length) {
			aplicarGrupos(embedded);
		} else {
			box.show().html('<div style="color:#666;">Cargando precios de opciones…</div>');
		}

		try {
			let groups = win.posknCknCache[producto.id];
			if (!groups) {
				const resp = await $.ajax({
					url: 'pos-ajax.php',
					method: 'POST',
					dataType: 'json',
					cache: false,
					data: {
						action: 'ckn_get_composite',
						product_id: producto.id,
						tienda_id: win.posknTiendaSeleccionada ? win.posknTiendaSeleccionada.id : 0,
						_t: Date.now(),
					},
					timeout: 15000,
				});
				if (resp && resp.success && resp.data && resp.data.groups) {
					groups = resp.data.groups;
					win.posknCknCache[producto.id] = groups;
				}
			}
			if (groups && groups.length) {
				aplicarGrupos(groups);
			} else if (!embedded.length) {
				box.hide().empty();
			}
		} catch (e) {
			if (!embedded.length) {
				box.hide().empty();
			}
		}
	};

	win.agregarAlCarrito = async function agregarAlCarrito() {
		if (!win.productoActual) return;

		const cantidadInput = $('#modal-cantidad').val();
		if (!cantidadInput || cantidadInput.trim() === '') {
			win.mostrarNotificacion('Por favor ingrese una cantidad', 'error');
			return;
		}
		const cantidad = parseFloat(cantidadInput);
		if (isNaN(cantidad) || cantidad <= 0) {
			win.mostrarNotificacion('La cantidad debe ser mayor a 0', 'error');
			return;
		}
		if (cantidad > 999.99) {
			win.mostrarNotificacion('La cantidad no puede ser mayor a 999.99', 'error');
			return;
		}

		const notas = $('#modal-notas').val();
		const variacionId = $('#modal-variacion-select').val();
		const variacionIdNum = parseInt(variacionId || '0', 10);
		const pa = win.productoActual;

		let precio = parseFloat(pa.price);
		let priceAnchor = pa.price_anchor || 'usd';
		let priceBsFixed = parseFloat(pa.price_bs_fixed || 0) || 0;
		let priceWcUsd = parseFloat(pa.price_wc_usd != null ? pa.price_wc_usd : pa.price) || 0;
		let nombreProducto = pa.name;
		let productoId = pa.id;
		let stockFallback = pa.stock;
		let stockManaging = win.posknResolveManagingStock(pa, variacionIdNum);

		let cknSelection = null;
		let cknOptionNames = [];
		let cknRespDeductParent = false;

		try {
			const resp = await $.ajax({
				url: 'pos-ajax.php',
				method: 'POST',
				dataType: 'json',
				cache: false,
				data: {
					action: 'ckn_get_composite',
					product_id: pa.id,
					tienda_id: win.posknTiendaSeleccionada ? win.posknTiendaSeleccionada.id : 0,
					_t: Date.now(),
				},
				timeout: 15000,
			});
			if (!win.productoActual) return;
			if (resp && resp.success && resp.data && typeof resp.data.deduct_parent_stock !== 'undefined') {
				cknRespDeductParent = !!resp.data.deduct_parent_stock;
			}
			if (resp && resp.success && resp.data && resp.data.groups && resp.data.groups.length) {
				win.posknCknCache[pa.id] = resp.data.groups;
				cknSelection = await win.mostrarSelectorComposite(resp.data.groups);
				if (!win.productoActual) return;
				if (!cknSelection) return;

				const groupsData = resp.data.groups;
				for (const [gIndex, sel] of Object.entries(cknSelection)) {
					const g = groupsData[parseInt(gIndex, 10)];
					if (!g || !Array.isArray(g.options)) continue;
					if (sel != null && typeof sel === 'object' && !Array.isArray(sel)) {
						Object.entries(sel).forEach(([idSel, qty]) => {
							if (!qty || qty < 1) return;
							const opt = g.options.find(
								(o) =>
									o != null &&
									(o.type === 'recipe' ? String(o.recipe_id) === String(idSel) : String(o.id) === String(idSel))
							);
							const nm = opt ? (opt.type === 'recipe' ? opt.label || opt.name : opt.name) : `Opción #${idSel}`;
							if (opt) cknOptionNames.push((nm || 'Opción') + (qty > 1 ? ` x${qty}` : ''));
						});
					} else {
						const raw = Array.isArray(sel) ? sel : [sel];
						raw.filter((id) => id != null && id !== '').forEach((idSel) => {
							const opt = g.options.find(
								(o) =>
									o != null &&
									(o.type === 'recipe' ? String(o.recipe_id) === String(idSel) : String(o.id) === String(idSel))
							);
							const nm = opt ? (opt.type === 'recipe' ? opt.label || opt.name : opt.name) : `Opción #${idSel}`;
							if (opt) cknOptionNames.push(nm || 'Opción');
						});
					}
				}
				let extra = 0;
				for (const [gIndex, sel] of Object.entries(cknSelection)) {
					const g = groupsData[parseInt(gIndex, 10)];
					if (!g || !Array.isArray(g.options)) continue;
					if (sel != null && typeof sel === 'object' && !Array.isArray(sel)) {
						Object.entries(sel).forEach(([idSel, qty]) => {
							const q = parseInt(qty, 10) || 0;
							if (q < 1) return;
							const opt = g.options.find(
								(o) =>
									o != null &&
									(o.type === 'recipe' ? String(o.recipe_id) === String(idSel) : String(o.id) === String(idSel))
							);
							if (opt) extra += (opt.type === 'recipe' ? parseFloat(opt.price_extra || 0) : parseFloat(opt.price || 0)) * q;
						});
					} else {
						const raw = Array.isArray(sel) ? sel : [sel];
						raw.filter((id) => id != null && id !== '').forEach((idSel) => {
							const opt = g.options.find(
								(o) =>
									o != null &&
									(o.type === 'recipe' ? String(o.recipe_id) === String(idSel) : String(o.id) === String(idSel))
							);
							if (opt) extra += opt.type === 'recipe' ? parseFloat(opt.price_extra || 0) : parseFloat(opt.price || 0);
						});
					}
				}
				precio += extra;
			}
		} catch (e) {
			console.error('CKN selector error', e);
		}

		if (!win.productoActual) return;

		if (!win._posknStockDegraded && typeof win.posknRefrescarStockEnVivo === 'function') {
			try {
				const refreshP = win.posknRefrescarStockEnVivo({ productIds: [win.productoActual.id] });
				await Promise.race([
					Promise.resolve(refreshP),
					new Promise((resolve) => win.setTimeout(resolve, 1500)),
				]);
				const freshAdd = win.posknFindProductoEnData(win.productoActual.id);
				if (freshAdd) {
					win.productoActual.stock = freshAdd.stock;
					win.productoActual.variations = freshAdd.variations;
				}
			} catch (refreshErr) {
				console.warn('No se pudo refrescar stock antes de agregar', refreshErr);
			}
		}

		if (variacionId && win.productoActual.variations && Array.isArray(win.productoActual.variations)) {
			const variacionSeleccionada = win.productoActual.variations.find((v) => v && v.id == variacionId);
			if (variacionSeleccionada) {
				const resolvedVar = win.posknResolvePreciosItem(variacionSeleccionada);
				precio = resolvedVar.usd;
				priceAnchor = variacionSeleccionada.price_anchor || 'usd';
				priceBsFixed = parseFloat(variacionSeleccionada.price_bs_fixed || 0) || 0;
				priceWcUsd =
					parseFloat(
						variacionSeleccionada.price_wc_usd != null ? variacionSeleccionada.price_wc_usd : variacionSeleccionada.price
					) || 0;
				nombreProducto += ` - ${Object.values(variacionSeleccionada.attributes).join(', ')}`;
				productoId = variacionId;
				stockFallback = variacionSeleccionada.stock;
				stockManaging = win.posknResolveManagingStock(win.productoActual, variacionId);
			}
		}

		const isComposite = !!(win.productoActual.is_composite || cknSelection || win.productoActual.composite_deduct_parent);
		const deductParent = !!(win.productoActual.composite_deduct_parent || cknRespDeductParent);
		const stockManagingResolved =
			stockManaging != null ? stockManaging : win.posknResolveManagingStock(win.productoActual, variacionIdNum);
		// Compuesto sin descuento de padre: no limita por qty del padre (solo componentes gestionados).
		const stockManagingForLimit = isComposite && !deductParent ? false : stockManagingResolved;
		const stockDisponible = win.posknGetStockDisponible(
			win.productoActual.id,
			variacionIdNum,
			stockFallback,
			stockManagingForLimit
		);
		const yaEnCarrito = win.posknCantidadEnCarrito(win.productoActual.id, variacionIdNum);
		if (stockDisponible !== null && yaEnCarrito + cantidad > parseFloat(stockDisponible) + 0.0001) {
			win.mostrarNotificacion(`Stock insuficiente. Disponible: ${parseFloat(stockDisponible).toFixed(2)}`, 'error');
			return;
		}

		const currentCknKey = cknSelection ? cknKeyFromSelection(cknSelection) : 'null';
		const carrito = win.carrito || (win.carrito = []);
		const existeIndex = carrito.findIndex(
			(item) =>
				!item.enCocina &&
				item.id === productoId &&
				item.notas === notas &&
				String(item.variacionId || '') === String(variacionId || '') &&
				String(item.cknKey || 'null') === String(currentCknKey)
		);

		if (existeIndex >= 0) {
			carrito[existeIndex].cantidad += cantidad;
			if (cknOptionNames.length > 0) {
				const prev = carrito[existeIndex].cknNames || [];
				carrito[existeIndex].cknNames = Array.from(new Set(prev.concat(cknOptionNames)));
			}
		} else {
			carrito.push({
				id: productoId,
				originalId: win.productoActual.id,
				name: nombreProducto,
				price: precio,
				priceAnchor,
				priceBsFixed,
				priceWcUsd,
				cantidad,
				notas,
				variacionId: variacionId || null,
				stockBaseId: win.productoActual.id,
				stockVariationId: variacionIdNum,
				stockFallback,
				stockManaging: stockManagingForLimit,
				ckn: cknSelection ? { groups: cknSelection } : null,
				cknNames: cknOptionNames,
				cknKey: currentCknKey,
				is_composite_kn: !!(
					win.productoActual.is_composite ||
					(cknSelection && typeof cknSelection === 'object' && Object.keys(cknSelection).length > 0)
				),
				composite_deduct_parent: deductParent,
				enCocina: false,
			});
		}

		win.actualizarCarrito();
		win.cerrarModal('modal-producto');
		let mensaje = 'Producto agregado al carrito';
		if (win.mesaSeleccionada) mensaje += ` (Mesa ${win.mesaSeleccionada.numero})`;
		win.mostrarNotificacion(mensaje, 'success');
	};
}
